export default __webpack_public_path__ + "static/media/tiger.036286c1.png";